module.exports = __webpack_public_path__ + "img/zclogo.cac70904.svg";